import { useState, useEffect } from "react";

const CreatePost = ({
  onClose,
  token,
  onPostCreated,

  initialData = {},
  lockedFields = {},
}) => {
  const [title, setTitle] = useState(initialData.title || "");
  const [gallery, setGallery] = useState(initialData.gallery || "");
  const [image, setImage] = useState(initialData.image || null);

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const MAX_FILE_SIZE = 5 * 1024 * 1024;
  const SUPPORTED_FILES = ["image/png", "image/webp", "image/jpeg"];

  // keep state in sync if parent updates props
  useEffect(() => {
    if (initialData.image) setImage(initialData.image);
  }, [initialData.image]);

  const validate = () => {
    console.log(image);
    if (!image) return "Image is required.";
    else{
      //Validate image
      if (!SUPPORTED_FILES.includes(image.type)) return "Unsupported file type\t.jpg, .webp, or .png allowed";
      if (image.size > MAX_FILE_SIZE) return "Image too large";
      
    }
    if (!title) return "Title is required.";
    if (!gallery) return "Gallery is required.";
  
    return null;
  };

  const  createThumbnail = async (width, height) => {
    const offscreen = new OffscreenCanvas(200,200);
    const context = offscreen.getContext('2d');
    const imgbitmap = await createImageBitmap(image);

    context.drawImage(imgbitmap,0,0, width, height);
    const resizedImage = await offscreen.convertToBlob({ type: 'image/webp'});

    return resizedImage;
  }

  const handleSubmit = async () => {
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }
 const thumbnail = await createThumbnail(200,200)
    console.log("thumbnail:\t", thumbnail); 

    setError("");
    setSubmitting(true);

    const formData = new FormData();
    formData.append("Title", title.trim());
    formData.append("Gallery", gallery.trim());
    formData.append("Image", image);
    formData.append("Thumbnail", thumbnail);

    const accessToken = token?.access_token || token;

    try {
      const res = await fetch("/api/gallery/posts", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || "Failed to create post");
      }

      onPostCreated?.();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <button style={closeButtonStyle} onClick={onClose}>
          ✕
        </button>

        <h2>Create Post</h2>

        {/* Can Lock image feild, uses provided image if locked */}
        {!lockedFields.image && (
          <div style={fieldStyle}>
            <label>Image</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setImage(e.target.files[0] || null)}
            />
          </div>
        )}

        {image && lockedFields.image && (
          <p style={{ fontSize: "0.9rem" }}>
            Uploading canvas image
          </p>
        )}

        <div style={fieldStyle}>
          <label>Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={inputStyle}
          />
        </div>

        <div style={fieldStyle}>
          <label>Gallery</label>
          <input
            type="text"
            value={gallery}
            onChange={(e) => setGallery(e.target.value)}
            style={inputStyle}
          />
        </div>

        {error && <p style={errorStyle}>{error}</p>}

        <button onClick={handleSubmit} disabled={submitting}>
          {submitting ? "Posting..." : "Post"}
        </button>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalStyle = {
  position: "relative",
  background: "#fff",
  color: "#000",
  padding: "2rem",
  borderRadius: "8px",
  width: "400px",
  maxWidth: "90vw",
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
};

const closeButtonStyle = {
  position: "absolute",
  top: "0.75rem",
  right: "0.75rem",
  background: "none",
  border: "none",
  fontSize: "1.2rem",
  cursor: "pointer",
};

const fieldStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
};

const inputStyle = {
  padding: "0.4rem",
  fontSize: "1rem",
};

const errorStyle = {
  color: "red",
  fontSize: "0.85rem",
};

export default CreatePost;